/**
 * customPageSandbox — cách BỌC script JSX của trang tuỳ biến (custompage) thành biểu thức hàm component, và danh sách "đồ nghề"
 * cấp sẵn cho script. File thuần (không import) để test backend (custompage-bien-dich-test, fetch-xac-thuc-test) đọc thẳng —
 * test và màn hình chạy cùng một cách bọc.
 *
 * HAI NHÓM TÊN:
 *   - DO_NGHE_GOC: tên đã có từ trước (React, MUI, apis, fetch…) — destructure như cũ ngay trong thân script.
 *   - DO_NGHE_O_NHAP (01/11/2026): bộ ô nhập giống form DataListManager (NumberField, DateField, RichTextEditor…). Tên mới dễ
 *     TRÙNG với tên script (kể cả script khách tự viết nằm trong DB) — vd script tự khai `const NumberField = …`. Nếu destructure
 *     cùng phạm vi với thân script thì trùng tên là LỖI CÚ PHÁP, trang đang chạy bỗng hỏng. Nên nhóm này được khai ở hàm NGOÀI,
 *     thân script chạy trong một hàm mũi tên bên trong: script khai trùng tên (const / let / var / function) thì tên của SCRIPT
 *     thắng, không lỗi. Hook vẫn gọi trong lúc render của cùng component (hàm trong được gọi đồng bộ, đúng một lần mỗi lần render).
 */

/** Đồ nghề có từ trước — giữ đúng thứ tự cũ (test fetch-xac-thuc kiểm dòng này có fetchXacThuc + fetch). */
export const DO_NGHE_GOC = ['React', 'MUI', 'ContainerGrid', 'context', 'quickAction', 'apis', 'config', 'userInfo', 'socket', 'page', 'history',
  'location', 'Markdown', 'slugify', 'TichHop', 'fetchXacThuc', 'fetch', 'ReactFlow', 'LookupField'];

/** Bộ ô nhập (CustomPageFields.jsx) — xem docs custompage-guide mục "Ô nhập liệu". */
export const DO_NGHE_O_NHAP = ['FieldControl', 'NumberField', 'DateField', 'DateTimeField', 'TimeField', 'MonthField', 'RichTextEditor', 'CodeEditor', 'JsonEditor'];

/**
 * Tiện ích giao diện dùng chung (03/11/2026): `HuongDanDialog` — hộp "Hướng dẫn" Y HỆT nút Hướng dẫn của usermodule /
 * DataListManager (Markdown GFM, mục lục, lọc mục, Copy Markdown, mở bản gốc). Khai ở hàm NGOÀI như bộ ô nhập: script tự khai
 * trùng tên thì tên của script thắng. Script nên đọc kiểu `typeof HuongDanDialog !== 'undefined' && HuongDanDialog` để vẫn
 * chạy trên frontend cũ chưa cấp tên này.
 */
export const DO_NGHE_TIEN_ICH = ['HuongDanDialog'];

/**
 * Bọc script thành biểu thức hàm `(function UserCustomPage(props){ … })` để đưa vào bienDichComponent.
 * Script không có `return ` thì coi cả script là JSX con của một Fragment (như trước).
 */
export function bocScriptTrang(script) {
  let body = String(script == null ? '' : script);
  if (!body.includes('return ')) body = 'return (\n<React.Fragment>\n' + body + '\n</React.Fragment>\n);';
  return '(function UserCustomPage(props){\n'
    + '  const { ' + DO_NGHE_O_NHAP.concat(DO_NGHE_TIEN_ICH).join(', ') + ' } = props;\n'
    + '  return (() => {\n'
    + '  const { ' + DO_NGHE_GOC.join(', ') + ', props: pageProps } = props;\n'
    + '  ' + body + '\n'
    + '  })();\n'
    + '})';
}

export default bocScriptTrang;
